import type { TimelineRecord } from '@/features/timeline/model/timeline-record';
import { TimelineValidator } from './timeline-validator';

export const normalizeRecord = (record: unknown): TimelineRecord | null => {
  if (!record || typeof record !== 'object') {
    return null;
  }

  const candidate = record as Partial<TimelineRecord> & Record<string, unknown>;
  if (typeof candidate.id !== 'string' || candidate.id.length === 0) {
    return null;
  }

  if (candidate.version !== '2.0') {
    return null;
  }

  const validation = TimelineValidator.validate(candidate.data);
  if (!validation.valid || !validation.data) {
    return null;
  }

  if (typeof candidate.$schema !== 'string') {
    return null;
  }

  return {
    $schema: candidate.$schema,
    id: candidate.id,
    version: '2.0',
    data: validation.data,
  };
};

export const isBrowser = (): boolean => {
  return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
};
